(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-bak"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          this.navigationResetHandler = this.reset.bind(this);
          window.addEventListener('on:breakpoint-change', this.navigationResetHandler);
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen && !this.toggle.matches('.js-sidebar-hover')) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
        this.closest('main-menu')?.syncSidebarPanels?.();
      }

      handleToggle(e) {
        if (this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches) {
          e.preventDefault();
          if (this.toggle.matches('.js-sidebar-hover')) {
            MainMenu.handleSidenavMenuToggle(e, this.toggle);
          }
        } else {
          super.handleToggle(e);
        }
      }

      disconnectedCallback() {
        window.removeEventListener('on:breakpoint-change', this.navigationResetHandler);
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["industry-pilot-intro"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('industry-pilot')) {
  customElements.define('industry-pilot', class extends HTMLElement {
    connectedCallback() {
      this.mark = this.mark.bind(this);
      const params = new URLSearchParams(location.search);
      const legacyKey = this.dataset.legacyKey ? `filter.p.m.custom.${this.dataset.legacyKey}` : '';
      const oldValue = legacyKey ? params.get(legacyKey) : null;
      const newValue = oldValue ? `${this.dataset.collection}::${oldValue}` : null;
      const validLegacy = newValue && [...this.querySelectorAll('[data-sp-level]')].some(a => a.dataset.spLevel === newValue);
      if (validLegacy && !params.has(this.dataset.filterKey)) {
        params.delete(legacyKey);
        params.set(this.dataset.filterKey, newValue);
        location.replace(`${location.pathname}?${params.toString()}${location.hash}`);
        return;
      }
      if (!window.twrgIndustryHistory) {
        window.twrgIndustryHistory = true;
        ['pushState', 'replaceState'].forEach(method => {
          const original = history[method];
          history[method] = function (...args) {
            const result = original.apply(this, args);
            window.dispatchEvent(new Event('twrg:industry-location'));
            return result;
          };
        });
      }
      window.addEventListener('twrg:industry-location', this.mark);
      window.addEventListener('popstate', this.mark);
      this.mark();
    }
    disconnectedCallback() {
      window.removeEventListener('twrg:industry-location', this.mark);
      window.removeEventListener('popstate', this.mark);
    }
    mark() {
      const current = new URLSearchParams(location.search).getAll(this.dataset.filterKey).flatMap(v => v.split(','));
      this.querySelectorAll('[data-sp-level], [data-sp-all]').forEach(a => {
        const active = a.hasAttribute('data-sp-all') ? current.length === 0 : current.includes(a.dataset.spLevel);
        a.classList.toggle('sp-tile--active', active);
        if (active) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["twrg-radio-rentals"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeRentalForms = (scope) => {
      scope.querySelectorAll('[data-rental-page]').forEach((page) => {
        const form = page.querySelector('.twrg-rentals__form');
        if (!form || form.dataset.rentalInitialized) return;
        form.dataset.rentalInitialized = 'true';
        const start = form.querySelector('[data-rental-start]');
        const end = form.querySelector('[data-rental-end]');
        if (start && end) {
          const updateDates = () => {
            const now = new Date();
            const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
            start.min = today;
            end.min = start.value > today ? start.value : today;
            const invalidRange = start.value && end.value && end.value < start.value;
            end.setCustomValidity(invalidRange ? end.dataset.rangeError : '');
            if (invalidRange) end.setAttribute('aria-invalid', 'true');
            else end.removeAttribute('aria-invalid');
          };
          start.addEventListener('input', updateDates);
          end.addEventListener('input', updateDates);
          form.addEventListener('submit', (event) => {
            updateDates();
            if (!form.checkValidity()) {
              event.preventDefault();
              form.reportValidity();
            }
          });
          updateDates();
        }
        const notice = form.querySelector('[data-rental-notice]');
        if (notice) {
          notice.focus({ preventScroll: true });
          notice.scrollIntoView({ block: 'center' });
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeRentalForms(document));
    else initializeRentalForms(document);
    document.addEventListener('shopify:section:load', (event) => initializeRentalForms(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
